<template>
  <div class="two" :class="{'gudingo':guding}" id="yuanshu1">
    <div class="T_title1" :style="{width:rlist[0]+'%'}">院校名称</div>
    <div class="T_title2" :style="{width:rlist[1]+'%'}">类型</div>
    <div class="T_title3" :style="{width:rlist[2]+'%'}">所在地</div>
    <div class="T_title4" :style="{width:rlist[3]+'%'}">隶属于</div>
    <div class="T_title5" :style="{width:rlist[4]+'%'}">性质</div>
    <div class="T_title6"  :style="{width:rlist[5]+'%'}">专业</div>
    <div class="T_title10" v-if="tianbaoType!=0" :style="{width:rlist[9]+'%'}">选科</div>
    <!-- v-if="tianbaoType!=0" -->
    <div class="T_title7"  :style="{width:rlist[6]+'%'}">计划</div>
    <div class="T_title8" :style="{width:rlist[7]+'%'}">
      <div class="T_title8top">近年录取统计</div>
      <div class="T_title8bot">
        <div>年份</div>
        <div>录取数</div>
        <div>最低分</div>
        <div>位次</div>
        <div>线差</div>
      </div>
    </div>
    <div class="T_title9" :style="{width:rlist[8]+'%'}">操作</div>
  </div>
</template>

<script>
  export default {
    props:{
      guding:{
        type:Boolean
      },
      typename:{
        type:String
      }
    },
    watch:{
      typename(vl){
        console.log(vl)
        this.rlist = this.$utils.getHeardrListfen(this.tianbaoType,vl)
      }
    },
    data(){
      return {
        rlist:[],
        tianbaoType: this.$utils.getlocalStorage('tianbaoType')
      }

    },
    created() {
      this.rlist = this.$utils.getHeardrListfen(this.tianbaoType,this.typename)
    }
  }
</script>

<style scoped>
  .gudingo {
      position: fixed;
      top: 70px;
      left: ;
      -webkit-transform: translate(0);
      transform: translate(0);
      margin-top: 0 !important;
      width: 1280px !important;
      z-index: 1;
  }
  .gudingo div {
    flex-shrink: 0;
  }

  /* 表格表头 */
  .two {
    display: flex;
    width: 1280px;
    height: 70px;
    background-color: #f66464;
    margin-top: 20px;
    border-radius: 2px;
    font-size: 17px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 50px;
    color: #ffffff;
    justify-content: center;
    align-items: center;
  }

  .two .T_title1 {
  	width: 20%;
  	text-align: center;
  }

  .two .T_title2 {
  	width: 5%;
  	text-align: center;
  }

  .two .T_title3 {
  	width: 5%;
  	text-align: center;
  }

  .two .T_title4 {
  	width: 8%;
  	text-align: center;
  }

  .two .T_title5 {
  	width: 5%;
  	text-align: center;
  }

  .two .T_title6 {
  	width: 14%;
  	text-align: center;
  }

  .two .T_title7 {
  	width: 5%;
  	text-align: center;
  }

  .two .T_title8 {
  	width: 24%;
  	text-align: center;
  	display: flex;
  	flex-direction: column;
  	border-left: 1px solid rgba(255, 255, 255, 0.3);
  	border-right: 1px solid rgba(255, 255, 255, 0.3);
  }

  .T_title8top {
  	display: flex;
    line-height: 30px;
  	align-items: center;
  	justify-content: center;
  	border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  }

  .T_title8bot {
  	display: flex;
  	justify-content: space-evenly;
  }

  .two .T_title9 {
  	width: 8%;
  	text-align: center;
  }
  .two .T_title10 {
  	width: 6%;
  	text-align: center;
  }

  .T_title8bot div {
    line-height: 30px;
  }

</style>



// WEBPACK FOOTER //
// src/components/tianbaoHeader/yuanfenHeader.vue